/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';

interface IGutter {
  size?: number;
  direction?: 'horizontal' | 'vertical';
}

const Gutter: React.FC<IGutter> = ({ size = 1, direction = 'horizontal' }) => {
  return (
    <div
      style={{
        [direction === 'horizontal' ? 'width' : 'height']: `${size * 8}px`,
        display: direction === 'horizontal' ? 'inline-block' : 'block'
      }}
    />
  );
};

export default Gutter;
